interface BootstrapModalPrototype {
	$element: JQuery;
	enforceFocus: () => void;
}

/**
 * Lets a React dialog keep the focus it takes while a legacy Bootstrap modal is open.
 *
 * Bootstrap 3's own `enforceFocus` binds one `focusin` handler on the document and pulls focus
 * back into its modal whenever focus lands anywhere else. A Base UI dialog renders in a portal
 * on the body, so it always counts as "anywhere else": Bootstrap takes the focus, Base UI's
 * focus trap takes it back, and the two fight over every focus change. The replacement below
 * exempts targets inside a portalled popup — `[data-base-ui-portal]` marks every Base UI portal
 * root — and is otherwise identical to the original, so every other target keeps the legacy
 * behaviour.
 *
 * Deliberately global rather than opt-in per dialog: it covers every portalled popup, including
 * ones nobody thought about (Select, Combobox, Menu), and it leaves the call sites free of any
 * knowledge about it. Delete this file once the last legacy Bootstrap modal is gone.
 */
export function allowPortalledPopupFocus() {
	const fn = $.fn as unknown as {modal: {Constructor: {prototype: BootstrapModalPrototype}}};
	fn.modal.Constructor.prototype.enforceFocus = function (this: BootstrapModalPrototype) {
		$(document)
			.off("focusin.bs.modal")
			.on("focusin.bs.modal", (event) => {
				const target: EventTarget = event.target;
				if (document === target || this.$element[0] === target) {
					return;
				}
				if (!(target instanceof Element)) {
					return;
				}
				if (this.$element.has(target).length > 0 || target.closest("[data-base-ui-portal]") != null) {
					return;
				}
				this.$element.trigger("focus");
			});
	};
}
